'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _paymentForm = require('./payment-form');

var _paymentForm2 = _interopRequireDefault(_paymentForm);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PaymentModal = _react2['default'].createClass({
    displayName: 'PaymentModal',


    // NOTE: These propTypes are incomplete - see render() for all props
    propTypes: {
        'tabOffset': _react2['default'].PropTypes.number,
        'paymentForm': _react2['default'].PropTypes.object,
        'numSeats': _react2['default'].PropTypes.number,
        'formAction': _react2['default'].PropTypes.string,
        'headerText': _react2['default'].PropTypes.string,
        'forceFreeTrial': _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            'cardType': 'Unknown',
            'cardNumber': '0',
            'cardCvv': '000',
            'cardExpMonth': '01',
            'cardExpYear': '2015',
            'stripe_token': '',
            'termsAccepted': false,
            'isProcessing': false,
            'isApi': true,
            'cardHolderName': this.props.cardHolderName ? this.props.cardHolderName : ''

        };
    },
    componentDidMount: function componentDidMount() {
        if (process.env.NODE_ENV !== 'test') {
            var root = $(_reactDom2['default'].findDOMNode(this));

            $(document).foundation();

            root.closest('.reveal-modal').foundation('reveal', 'open');

            (0, _setTimeout2['default'])(function () {
                var input = root.find('input:first');
                input.focus();
            }, 500);
        }
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
        if (process.env.NODE_ENV !== 'test') {
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    checkIfDowngrade: function checkIfDowngrade() {
        return this.props.timePeriod == 'M' ? this.props.currentMonthlyRate > this.props.monthlyExpectedRate : this.props.currentAnnualRate > this.props.annualExpectedRate;
    },
    render: function render() {

        var rateString = _hfReactHelper2['default'].formatMoney(this.props.timePeriod == 'M' ? this.props.monthlyExpectedRate : this.props.annualExpectedRate, '$');

        var billingString = 'Your 30 day trial starts today. Within those 30 days, if you change your mind, you can cancel your account and you won\'t be charged. After your free trial, we\'ll begin billing you ' + rateString + '/' + (this.props.timePeriod == 'M' ? 'mo' : 'yr') + '.';
        var downgradingToFree = false;
        if (!this.props.forceFreeTrial && this.props.isApi) {
            billingString = 'You will be billed ' + rateString + ' today. We will refund you in full within 30 days of your purchase if you are unhappy with our service for any reason.';
        } else if (this.props.isTrialing) {
            if (rateString === '$0') {
                billingString = 'Downgrading will end your free trial and you will not be charged. You can upgrade at any time.';
                downgradingToFree = true;
            } else {
                billingString = 'You will be billed ' + rateString + ' at the end of your existing free trial.';
            }
        } else if (this.props.timePeriod == 'M' && this.props.monthlyExpectedRate !== this.props.monthlyProratedRate || this.props.timePeriod == 'Y' && this.props.annualExpectedRate !== this.props.annualProratedRate) {
            // need to display prorated information
            var isDowngrade = this.checkIfDowngrade();
            if (isDowngrade) {
                billingString = 'At the beginning of your next billing cycle you will be billed ' + rateString + '.';
            } else {
                var proratedRateString = _hfReactHelper2['default'].formatMoney(this.props.timePeriod == 'M' ? this.props.monthlyProratedRate : this.props.annualProratedRate, '$');
                billingString = 'You will be charged ' + proratedRateString + ' for your current pro-rated billing cycle. Starting with your next billing cycle, you will be charged ' + rateString + '/' + (this.props.timePeriod == 'M' ? 'mo' : 'yr') + '.';
            }
        } else if (!this.props.isFreeTrialEligible) {
            var isDowngrade = this.checkIfDowngrade();
            if (isDowngrade) {
                billingString = 'At the beginning of your next billing cycle you will be billed ' + rateString + '.';
            } else {
                billingString = 'You will be billed ' + rateString + ' today.';
            }
        } else if (!this.props.forceFreeTrial && this.props.monthlyExpectedRate <= 0) {
            billingString = _react2['default'].createElement(
                'span',
                null,
                'When you downgrade to a Free plan you will lose access to our paid features, including templates. But fear not! You will still have full access to your account and any signed documents you\'ve saved.',
                _react2['default'].createElement('br', null),
                _react2['default'].createElement('br', null),
                'You can upgrade at any time to restore the applicable paid features and increase the number of documents and templates you can use.'
            );
        }

        if (!downgradingToFree) {
            var supportEmail = _hfReactHelper2['default'].HfConstants.supportEmail[_hfReactHelper2['default'].HfSites.SITE_CODE_HS];
            billingString = _react2['default'].createElement(
                'span',
                null,
                billingString,
                _react2['default'].createElement('br', null),
                _react2['default'].createElement('br', null),
                'If you have any questions, you can reach our support team at\xA0',
                _react2['default'].createElement(
                    'a',
                    { href: 'mailto:' + supportEmail },
                    supportEmail
                ),
                '.'
            );
        }

        var headerText;
        if (this.props.headerText) {
            headerText = this.props.headerText;
        } else {
            headerText = 'Sign up for ' + this.props.name;
            var currentRate = this.props.timePeriod == 'Y' ? parseFloat(this.props.currentAnnualRate) : parseFloat(this.props.currentMonthlyRate);
            if (!this.props.isApi && currentRate == 0.0 && this.props.isFreeTrialEligible) {
                headerText = 'Start ' + this.props.name + ' Trial';
            } else if (this.props.isUpgrade) {
                headerText = 'Upgrade to ' + this.props.name;
            } else {
                headerText = 'Downgrade to ' + this.props.name;
            }
        }

        var card = {
            'name': this.props.cardHolderName,
            'suffix': this.props.ccSuffix
        };

        return _react2['default'].createElement(_paymentForm2['default'], { fields: this.props.paymentForm.fields,
            values: this.props.paymentForm.values,
            errors: this.props.errors,
            namespace: this.props.paymentForm.namespace,
            stripeToken: this.state.stripe_token,
            planId: this.props.planId,
            couponCode: this.props.couponCode,
            timePeriod: this.props.timePeriod,
            tabOffset: this.props.tabOffset,
            card: card,
            isApi: this.props.isApi,
            isEventbrite: this.props.isEventbrite,
            termsAccepted: this.props.termsAccepted,
            buttonText: this.props.buttonText,
            headerText: headerText,
            billingString: billingString,
            ccExpiration: this.props.ccExpiration,
            numSeats: this.props.numSeats,
            formAction: this.props.formAction,
            currentPlanName: this.props.currentPlanName,
            name: this.props.name });
    }
});

module.exports = PaymentModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-modal.jsx
 ** module id = 1062
 ** module chunks = 0
 **/